/**
 * 宽度变化动画
 */
import fvAnimation from "./fvAnimation"
export default class fvWidth extends fvAnimation {     
    constructor(shape){
        super(shape,"fvWidth");
        //获取宽
        this.org = this.orgWidth;
        this.orgWidth = shape.width;
        this.orgX = shape.x;
        this.sizeFunction = AsyncFunction("return " + this.expression);
        this.MaxPerc = AsyncFunction("return " + this.MaxPerc);
        this.MinPerc = AsyncFunction("return " + this.MinPerc);
    }

    async run(canvas,value){ 
        //if(value == false) return;
        var size = await this.executionScript(this.sizeFunction);
        var MaxPercValue = await this.executionScript(this.MaxPerc);
        var MinPercValue = await this.executionScript(this.MinPerc);
        if(this.MaxValue == this.MinValue) return;
        if(size == -9999) return; 
        if(this.shape.fctype.indexOf('Obj') >= 0){
            this.shape.width=(this.orgWidth/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100);
            if(this.shape.width>this.orgWidth){
                this.shape.width=this.orgWidth;
                if(this.shape.width <0){
                    this.shape.width=0; 
                }
            }
            switch(parseInt(this.org)){
                case 0:
                    break;
                case 50:
                    this.shape.cx = this.orgX + (this.orgWidth-this.shape.width)/2;
                    console.log(this.shape.cx);
                    break;
                case 100:
                    this.shape.cx = this.orgX + this.orgWidth-this.shape.width;
                    console.log(this.shape.cx);
                    break;
                default:
                    break;
            }
        }else{
            //位图的动画
            canvas.domStyle.width= (parseFloat(canvas.picWidth)/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100)+"px";
            canvas.picStyle.width = (parseFloat(canvas.picWidth)/(MaxPercValue - MinPercValue)*(size - this.MinValue))*((this.MaxValue - this.MinValue)/100)+"px";
            if(parseFloat(canvas.picStyle.width)>parseFloat(canvas.picWidth)){
                canvas.domStyle.width=parseFloat(canvas.picWidth)+"px";
                canvas.picStyle.width=parseFloat(canvas.picWidth)+"px";
                if(parseFloat(canvas.picStyle.width) <0){
                    canvas.domStyle.width="0px"; 
                    canvas.picStyle.width="0px"; 
                }
            }
            switch(parseInt(this.org)){
                case 0:
                    break;
                case 50:
                    canvas.domStyle.left = this.orgX + (this.orgWidth-this.shape.width)/2+"px";
                    break;
                case 100:
                    canvas.domStyle.left = this.orgX + this.orgWidth-this.shape.width+"px";
                    break;
                default:
                    break;
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/js/canvas/animation/fvWidth.js